import { createFileRoute, Outlet } from '@tanstack/react-router';
import { ApiError } from '@/lib/api-client';
import { fetchCurrentUser } from '@/lib/auth';

// Layout autenticado sem AppShell. Pra rotas que precisam abrir em aba
// limpa (sem sidebar/topbar) — ex.: relatório pra imprimir como PDF.
export const Route = createFileRoute('/_print')({
  beforeLoad: async ({ context, location }) => {
    try {
      const user = await context.queryClient.fetchQuery({
        queryKey: ['auth', 'me'],
        queryFn: ({ signal }) => fetchCurrentUser(signal),
        staleTime: 5 * 60_000,
      });
      return { user };
    } catch (e) {
      if (e instanceof ApiError && e.status === 401) {
        if (typeof window !== 'undefined') {
          const target = `/auth/login?redirect=${encodeURIComponent(location.href)}`;
          window.location.replace(target);
        }
        throw new Error('redirecting-to-auth');
      }
      throw e;
    }
  },
  component: () => <Outlet />,
});
